export default __webpack_public_path__ + "1f77ed5b7c4cfb44ea35feeae25d7a8c.svg";